import { Action } from 'redux';

import { CollectionVisibility } from '~src/app/spaces/Collections/CollectionModels';
import { SetCollectionVisibility } from '../../AppActionTypes';
import { isActionFactory } from '../../isActionFactory';

export interface SetCollectionVisibilityAction extends Action {
  contentIds: string[];
  visibility: CollectionVisibility;
}

export function setCollectionVisibility(contentIds: string[], visibility: CollectionVisibility): SetCollectionVisibilityAction {
  return {
    type: SetCollectionVisibility,
    contentIds,
    visibility
  };
}

export const isSetCollectionVisibility = isActionFactory<SetCollectionVisibilityAction>(SetCollectionVisibility);
